import React from "react";
import { FaTimesCircle } from 'react-icons/fa';
import './subscription.css';
import Footer from "../components/Footer/footer";
import DashboardNavbar from "../components/Navbar/navbar-dashboard";
import { useNavigate } from "react-router-dom";

const CancelPage = () =>
{
  const navigate = useNavigate();

  return (
    <>
      <DashboardNavbar prefix={'Biz '} />
      <div className="cancel-page">
        <div className="cancel-content">
          <FaTimesCircle className="cancel-icon" />
          <h1>Subscription Canceled</h1>
          <p>We're sorry to see you go! If you have any questions or need assistance, feel free to contact our support team.</p>
          <button className="back-button" onClick={() => (navigate('/businessdash'))}>Return to Home</button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CancelPage;